/**
 * Determines if a page view should be tracked based on pathname.
 * Skips if path is "/" or contains "NaN", "null", or "0" segments.
 */
export const shouldTrackPageView = (pathname) => {
  if (pathname === '/') {
    return false;
  }
  return !/(\/(NaN|null|0)(\/|$))/i.test(pathname);
};
